import { Component } from '@angular/core';

import { AuthService } from '../services';
import { AVANO_ERROR_NUMBERS } from '../shared';

@Component({
  selector: 'scip-error-page',
  templateUrl: './scip-error-page.component.html'
})
export class ScipErrorPageComponent {
  errorToShow: AVANO_ERROR_NUMBERS;

  constructor(private authService: AuthService) {
    // Currently this component only gets displayed when the user is unauthorized for SCIP (no SCIP roles)
    // Therefore we can hard code the error. But if we want to react to e.g. an unused route we can adapt this
    // component here.
    this.errorToShow = AVANO_ERROR_NUMBERS.UNAUTHORIZED_401;
  }

  backToLogin(): void {
    this.authService.logout();
  }
}
